export default "__VITE_ASSET__OtZpj5$R__"